import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import { Card, CardHeader, Nav, NavItem, NavLink, CardBody, Button, Col, Input, Row, Label, ModalBody, Form, TabPane, TabContent, Spinner, FormFeedback, FormGroup, Alert, CardFooter } from 'reactstrap';
import OSelect from '../../../Components/OElements/OSelect';
import { DatePickerInput, DatesProvider } from '@mantine/dates';
import { ODataGrid } from '../../../Components/OElements/ODataGrid';
import { mimeTypeToIconMapping } from '../../../helpers/mime-type_to_icon';
import PhotographicRecordModal from '../Modals/PhotographicRecordModal';
import DeletePhotographicRecordModal from '../Modals/DeletePhotographicRecordModal';
import { Icons } from '../../../utils/Icons';

const PhotographicRecordsTab = ({
    photographicRecordsList,
    handlePhotographicRecordsList,
    selectedSector,
    dataBeachCleaning
}) => {
    const [dataPhotographicRecord, setDataPhotographicRecord] = useState(null);
    const [isEdit, setIsEdit] = useState(false);
	const [modal, setModal] = useState(false);
    const [toggleTab, setToggleTab] = useState(null);
    const [modalDelete, setModalDelete] = useState(false);

    // Update Data
	const handleClickEdit = residueCollected => {
		setDataPhotographicRecord(residueCollected);
		handleToggleModal();
	};
    
    // Delete Data
	const handleClickDelete = photographicRecord => {
		setDataPhotographicRecord(photographicRecord);
		handleToggleModalDelete();
	};

    function handleToggleModal() {
		setModal(!modal);
		// setToggleTab('1');
		// validation.resetForm();
	}

    function handleToggleModalDelete() {
		setModalDelete(!modalDelete);
		// setToggleTab('1');
		// validation.resetForm();
	}
    
    const columns = useMemo(
		() => [
			{
				header: 'Acciones', enableSorting: false, enableColumnFilter: false, enableGlobalFilter: false, enableColumnActions: false, enableSorting: false, enableColumnFilter: false, enableGlobalFilter: false, enableColumnActions: false,
				accessorKey: 'residue',
                columnDefType: 'display',
				 size: 'auto',
				Cell: cellProps => {
					const rowData = cellProps.row.original;
					return (
						<React.Fragment>
							<div className='d-flex justify-content-center'>
								<div className='flex-shrink-0'>
									<ul className='list-inline mb-0'>
										<li className='list-inline-item'>
											<Link
												title={'Editar'}
												to='#'
												onClick={event => {
													event.preventDefault();
													handleClickEdit(rowData);
												}}
											>
												<i className='ri-pencil-fill align-bottom me-2 text-muted'></i>
											</Link>
										</li>
										<li className='list-inline-item'>
											<Link
												title={'Eliminar'}
												to='#'
												className='remove-item-btn'
												onClick={event => {
													event.preventDefault();
													handleClickDelete(rowData);
												}}
											>
												<i className='ri-delete-bin-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</React.Fragment>
					);
				},
			},
			{
                header: 'Nombre',
                accessorKey: 'document[0]',
                filterVariant: 'autocomplete',
                Cell: cellProps => {
					return (
						<div className='d-flex align-items-center'>
							<div className='flex-grow-1 filelist-name'>
								{(
                                    (Array.isArray(cellProps.row.original?.document) && cellProps.row.original?.document.length)
                                        ?
                                        (
                                            cellProps.row.original.document[0].filename +
                                            cellProps.row.original.document[0].extension
                                        )
                                        :
                                        cellProps.row.original.document?.name || ''
                                )}
							</div>
						</div>
					);
				},
            },
            { header: 'Tipo de registro', accessorKey: 'record_type.name',  size: 'auto' },
            { header: 'Latitud', accessorKey: 'latitude',  size: 'auto' },
            { header: 'Longitud', accessorKey: 'longitude',  size: 'auto' },
		],
		[handleClickEdit]
	);

    return (
        <React.Fragment>
            <Col lg={12}>
                {/* <div className='d-flex align-items-center'>
                    <h5 className='card-title mb-0 flex-grow-1 '>
                        Registros Fotográficos
                    </h5>
                    <div className='flex-shrink-0'>
                        <div className='d-flex flex-wrap gap-2'>
                            <button
                                className='btn btn-label btn-primary'
                                onClick={() => {
                                    setIsEdit(false);
                                    setDataPhotographicRecord({});
                                    handleToggleModal();
                                }}
                                type='button'
                            >
                                <i className={`${Icons.plus} label-icon`}></i> Agregar Registro Fotográfico
                            </button>
                        </div>
                    </div>
                </div> */}
                <div className='mt-3 my-4'>
                    <ODataGrid
                        columns={columns}
                        data={photographicRecordsList || []}
                        customToolbarActions={[
							{
								label: 'Agregar',
								icon: Icons.plus,
								className: 'gap-1',
								onClick: () => {
                                    setIsEdit(false);
                                    setDataPhotographicRecord({});
                                    handleToggleModal();
                                },
								title: 'Agregar Registro Fotográfico',
							}
						]}
                    />
                </div>
            </Col>
            <PhotographicRecordModal
                dataPhotographicRecord={
                    dataPhotographicRecord
                }
                isOpen={modal}
                isEdit={isEdit}
                handleToggleModal={handleToggleModal}
                photographicRecordsList={photographicRecordsList}
                handlePhotographicRecordsList={handlePhotographicRecordsList}
                selectedSector={selectedSector}
                dataBeachCleaning={dataBeachCleaning}
            />
            <DeletePhotographicRecordModal
                dataPhotographicRecord={
                    dataPhotographicRecord
                }
                isOpen={modalDelete}
                handleToggleModal={handleToggleModalDelete}
                photographicRecordsList={photographicRecordsList}
                handlePhotographicRecordsList={handlePhotographicRecordsList}
            />
        </React.Fragment>
    )
}

export default PhotographicRecordsTab;